import { createSlice } from "@reduxjs/toolkit";

const getInitialCart = () => {
  const storedCart = localStorage.getItem("cart");
  return storedCart ? JSON.parse(storedCart) : [];
};

const CartSlice = createSlice({
  name: "cart",
  initialState: {
    cart: getInitialCart(),
  },
  reducers: {
    addToCart: (state, action) => {
      const existingItem = state.cart.find(item => item._id === action.payload._id);
      if (existingItem) {
        existingItem.quantity += 1;
      } else {
        state.cart.push({ ...action.payload, quantity: 1 });
      }
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },

    removeFromCart: (state, action) => {
      state.cart = state.cart.filter(item => item._id !== action.payload._id);
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },

    incrementQuantity: (state, action) => {
      state.cart = state.cart.map(item =>
        item._id === action.payload._id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      );
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },

    decrementQuantity: (state, action) => {
      state.cart = state.cart
        .map(item =>
          item._id === action.payload._id
            ? { ...item, quantity: item.quantity - 1 }
            : item
        )
        .filter(item => item.quantity > 0); // Remove items with quantity 0

      localStorage.setItem("cart", JSON.stringify(state.cart));
    },


    manualQuantity: (state, action) => {
      state.cart = state.cart.map(item =>
        item._id === action.payload._id
          ? { ...item, quantity: action.payload.quantity }
          : item
      );
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },

    initializeCart: (state, action) => {
      state.cart = action.payload;
      localStorage.setItem("cart", JSON.stringify(action.payload));
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  incrementQuantity,
  decrementQuantity,
  manualQuantity,
  initializeCart
} = CartSlice.actions;

export default CartSlice.reducer;
